<script setup lang="ts">
import { computed, ref } from 'vue';
import { UiText, UiIcon } from '@shopexperts/shared';

const props = defineProps<{
    label: string;
}>();

const rating = defineModel<number>({ default: 0 });

const stars = [1, 2, 3, 4, 5];
const hoveredStar = ref<number | null>(null);

const selectRating = (value: number) => {
    rating.value = value;
};

const onMouseEnter = (star: number) => {
    hoveredStar.value = star;
};

const onMouseLeave = () => {
    hoveredStar.value = null;
};

const isStarFilled = (star: number) => {
    const targetRating = hoveredStar.value !== null ? hoveredStar.value : rating.value;
    return star <= targetRating;
};

const formattedRating = computed(() => {
    return rating.value > 0 ? rating.value.toFixed(1) : '0.0';
});
</script>

<template>
    <div class="flex flex-col items-start gap-1 sm:flex-row sm:items-center sm:justify-between w-full">
        <UiText as="p" variant="p" class="text-se-gray-900">
            {{ props.label }}
        </UiText>
        <div class="flex gap-2 items-center">
            <div class="flex gap-0.5 items-start">
                <button
                    v-for="star in stars"
                    :key="star"
                    type="button"
                    @click="selectRating(star)"
                    @mouseenter="onMouseEnter(star)"
                    @mouseleave="onMouseLeave"
                    class="relative shrink-0 size-8 transition-transform hover:scale-110 focus:outline-none"
                    :aria-label="`Rate ${star} out of 5`"
                >
                    <UiIcon
                        :name="isStarFilled(star) ? 'star' : 'star'"
                        :class="[
                            'size-8',
                            isStarFilled(star) ? 'text-se-success' : 'grayscale opacity-40'
                        ]"
                    />
                </button>
            </div>
            <UiText as="p" variant="p" class="text-se-gray-900 font-semibold min-w-[2.5rem]">
                {{ formattedRating }}
            </UiText>
        </div>
    </div>
</template>

